import { gql } from '@biletiniz/apollo';

export const DUBAI_VISA_BOOKING_INFO_QUERY = gql`
  query GetDubaiVisaBookingInfo($session: String!) {
    dubaiVisaBookingInfo(session: $session) {
      providerContext {
        totalPrice
        currency
      }
      visaType
      passengers {
        givenName
        surname
        gender
        email
        telephone
        birthDate
        departureDate
        visaType
      }
      paymentCard {
        cardHolderName
        cardNumber
        cvc
        expireYear
        expireMonth
      }
    }
  }
`;
